var moduleMap = {
	"./single-spa": function() {
		return Promise.all([__webpack_require__.e(512), __webpack_require__.e(116), __webpack_require__.e(29), __webpack_require__.e(344), __webpack_require__.e(920)]).then(function() { return function() { return (__webpack_require__(86920)); }; });
	},
	"./player-preview": function() {
		return Promise.all([__webpack_require__.e(512), __webpack_require__.e(576), __webpack_require__.e(116), __webpack_require__.e(29), __webpack_require__.e(344), __webpack_require__.e(948), __webpack_require__.e(539)]).then(function() { return function() { return (__webpack_require__(40539)); }; });
	},
	"./batch-player-preview": function() {
		return Promise.all([__webpack_require__.e(512), __webpack_require__.e(576), __webpack_require__.e(116), __webpack_require__.e(29), __webpack_require__.e(344), __webpack_require__.e(948), __webpack_require__.e(627)]).then(function() { return function() { return (__webpack_require__(33627)); }; });
	},
	"./Player": function() {
		return Promise.all([__webpack_require__.e(512), __webpack_require__.e(576), __webpack_require__.e(543), __webpack_require__.e(116), __webpack_require__.e(29), __webpack_require__.e(344), __webpack_require__.e(948), __webpack_require__.e(774), __webpack_require__.e(167)]).then(function() { return function() { return (__webpack_require__(42774)); }; });
	},
	"./FixedFormPlayer": function() {
		return Promise.all([__webpack_require__.e(512), __webpack_require__.e(576), __webpack_require__.e(543), __webpack_require__.e(434), __webpack_require__.e(116), __webpack_require__.e(29), __webpack_require__.e(344), __webpack_require__.e(948), __webpack_require__.e(774), __webpack_require__.e(843), __webpack_require__.e(925)]).then(function() { return function() { return (__webpack_require__(77671)); }; });
	},
	"./LinkPlayer": function() {
		return Promise.all([__webpack_require__.e(512), __webpack_require__.e(116), __webpack_require__.e(29), __webpack_require__.e(344), __webpack_require__.e(723)]).then(function() { return function() { return (__webpack_require__(89723)); }; });
	},
	"./PlayerQueryWrapper": function() {
		return Promise.all([__webpack_require__.e(512), __webpack_require__.e(576), __webpack_require__.e(543), __webpack_require__.e(116), __webpack_require__.e(29), __webpack_require__.e(344), __webpack_require__.e(948), __webpack_require__.e(774), __webpack_require__.e(535)]).then(function() { return function() { return (__webpack_require__(89029)); }; });
	},
	"./microuis/fixedform-player": function() {
		return Promise.all([__webpack_require__.e(512), __webpack_require__.e(576), __webpack_require__.e(543), __webpack_require__.e(434), __webpack_require__.e(116), __webpack_require__.e(29), __webpack_require__.e(344), __webpack_require__.e(948), __webpack_require__.e(774), __webpack_require__.e(843), __webpack_require__.e(705)]).then(function() { return function() { return (__webpack_require__(36955)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});